
export default {
    props: {
        image: {
            type: Object,
            default: null
        },
        content: {
            type: String,
            default: null
        },
        author: {
            type: String,
            default: null
        },
    }
};
